<pos-app-spinner [show]="loading"></pos-app-spinner>
<div>
  <div class="modal-header">
    <h4 class="modal-title">SPLIT ORDER</h4>
  </div>
  <div class="modal-body">
    <div class="border mb-2">
      <div class="row row-gap m-2">
        <div class="col-4 d-flex align-items-center">
          <label class="col-4">ORDER</label>
          <div class="col-7">
            <input class="form-control" [value]="selectedOrder?.OrderNumber" [readonly]="true" />
          </div>
        </div>
        <div class="col-4 d-flex align-items-center">
          <label class="col-4">CUSTOMER</label>
          <div class="col-7">
            <input class="form-control" [value]="selectedOrder?.CustomerName" [readonly]="true" />
          </div>
        </div>
        <div class="col-3 d-flex align-items-center">
          <!-- <div class="col-11">
            <button type="button" class="btn" (click)="viewScheduleHistory()">
              SCHEDULE HISTORY&nbsp;<span class="badge badge-light ml-2 bg-dark"></span>
            </button>
          </div> -->
          <!-- <div class="col-1">
            <button type="button" class="btn" (click)="showNoteView()">NOTES</button>
          </div> -->
        </div>
      </div>
      <div class="row row-gap m-2">
        <div class="col-4 d-flex align-items-center">
          <label class="col-4">ORDER TYPE</label>
          <div class="col-7">
            <input class="form-control" [value]="selectedOrder?.JobType" [readonly]="true" />

            <!-- <ng-select formControlName="jobTypeCode" [clearable]="false">
              <ng-option *ngFor="let jobType of jobTypeList" [value]="jobType.code">
                {{ jobType.shortDescription }}
              </ng-option>
            </ng-select> -->
          </div>
        </div>
        <div class="col-4 d-flex align-items-center">
          <label class="col-4">PHONE</label>
          <div class="col-7 pr-2">
            <input class="form-control" [value]="selectedOrder?.CustomerPhone" [readonly]="true" />
          </div>
        </div>

        <div class="col-4 d-flex align-items-center">
          <label class="col-4">JOB OWNER</label>
          <div class="col-7 pr-2">
            <input class="form-control" [value]="selectedOrder?.JobOwner" [readonly]="true" />
          </div>
        </div>
      </div>

      <div class="row row-gap m-2">
        <div class="col-4 d-flex align-items-center">
          <label class="col-4">VEHICLE</label>
          <div class="col-7 pr-2">
            <input class="form-control" [value]="selectedOrder?.CarShortDesc" [readonly]="true" />
          </div>
        </div>
        <div class="col-4 d-flex align-items-center">
          <label class="col-4">REGO</label>
          <div class="col-7 pr-2">
            <input class="form-control" [value]="selectedOrder?.CarRego" [readonly]="true" />
          </div>
        </div>

        <div class="col-4 d-flex align-items-center">
          <label class="col-4">VEHICLE STATUS</label>
          <div class="col-7 pr-2">
            <input class="form-control" [value]="selectedOrder?.VehicleStatus" [readonly]="true" />
          </div>
        </div>
      </div>
    </div>
    <div class="row px-2 flex-nowrap fitter-row-position position-relative">
      <div cdkDropListGroup>
        <div *ngFor="let jobGroup of this.formGroup.get('jobGroup')['controls']; let i = index" class="border mb-2">
          <div style="background: lightgrey; padding-bottom: 1px" [formGroup]="jobGroup">
            <div>
              <div class="col-12 d-flex align-items-center">
                <div class="row row-gap">
                  <div class="d-flex align-items-center">
                    <div class="border mb-2">
                      <div class="row row-gap m-1">
                        <div class="col-3 d-flex align-items-center">
                          <label class="col-6">SPLIT</label>
                          <div class="col-4 pr-1">
                            <input class="form-control" formControlName="jobSplitNum" [readOnly]="true" />
                          </div>
                        </div>
                        <div class="col-3 d-flex align-items-center">
                          <label class="col-8">STANDARD HOURS</label>
                          <div class="col-4 pr-1">
                            <input class="form-control" formControlName="standardHours" [readOnly]="true" />
                          </div>
                        </div>
                        <div class="col-3 d-flex align-items-center">
                          <label class="col-8">SCHEDULED HOURS</label>
                          <div class="col-4 pr-1">
                            <input class="form-control" formControlName="scheduledHours" (input)="onChangeScheduledHours($event, i)" />
                          </div>
                        </div>
                        <div class="col-3 d-flex align-items-center">
                          <label class="col-4">FIT DATE</label>
                          <div class="col-8">
                            <div class="input-group">
                              <input
                                class="form-control"
                                formControlName="fitDate"
                                name="d2"
                                ngbDatepicker
                                #d="ngbDatepicker"
                                [dayTemplate]="customDay"
                                [footerTemplate]="footerTemplate"
                                [placement]="'left'"
                                container="body"
                                (dateSelect)="showDetails($event, i, d)"
                                (navigate)="navigateCalendar($event, i)"
                                autoClose="false"
                                (keydown)="checkAllowEditable($event)"
                                [startDate]="getToday()"
                                [markDisabled]="isDisabled"
                                />
                              <div class="input-group-append">
                                <button
                                  class="btn btn-secondary calendar text-white btn-picker"
                                  (click)="d.toggle()"
                                  (click)="streamOpened($event, i)"
                                  type="button"
                                ></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row row-gap">
                        <div class="col-9 d-flex align-items-center">
                          <label class="col-2 p-2">DESCRIPTION</label>
                          <div class="col-10 pr-1">
                            <input class="form-control" formControlName="description" (input)="onChangeDescription($event, i)" maxlength="100" />
                          </div>
                        </div>
                        <div class="col-3 d-flex align-items-center">
                          <label class="col-6">ALLOCATED</label>
                          <div class="col-6 pr-1">
                            <div class="col-2 pr-1 d-flex float-start mt-2">
                              <input type="checkbox" onclick="return false" formControlName="allocatedTF" />
                            </div>
                            <div class="col-6 pr-1 d-flex float-end">
                              <button (click)="remove(jobGroup, i)"><mat-icon>delete</mat-icon></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!jobGroup.get('orderLines')?.value" class="row d-flex align-items-center">
                <div class="col-10 d-flex justify-content-center"><label>DROP ITEM HERE TO ADD INTO NEW GROUP</label></div>
              </div>
              <div class="example-list" cdkDropList [cdkDropListData]="jobGroup.get('orderLines')?.value" (cdkDropListDropped)="drop($event)">
                <div class="example-box" *ngFor="let item of jobGroup.get('orderLines')?.value; let j = index" cdkDrag>
                  <div class="col d-flex align-items-center">
                    <div class="col-1 pr-1">
                      <input class="big-checkbox" type="checkbox" (click)="multiSelect(i, j, item, $event.target.checked)" />
                    </div>
                    {{ item.string }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="col d-flex float-start justify-content-start">
      <button class="btn btn-cancel mx-1 px-2 flex" (click)="addNewEmptyGroup()">CREATE NEW EMPTY GROUP</button>
    </div>
    <div *ngIf="unAssignedOrdersList[0].subtotalsTF && !autoSplitTF" class="col d-flex float-start justify-content-start">
      <button class="btn btn-cancel mx-1 px-2 flex" (click)="autoSplit()">AUTO SPLIT ACCORDING TO SUBTOTALS</button>
    </div>
    <div class="col d-flex float-end justify-content-end">
      <button *ngIf="orderLineMoved" class="btn btn-cancel mx-1 px-2" (click)="resetSplitOrders()">RESET</button>
      <button class="btn text-white mx-1 px-2" [disabled]="!splitValid" (click)="submitSplitOrder(true)">SAVE</button>
      <button class="btn btn-cancel mx-1 px-2" (click)="this.activeModal.close(false)">CANCEL</button>
    </div>
  </div>

  <p-confirmDialog header="Warning" #overCurrentSplitConfirmation key="overCurrentSplitConfirmation">
    <p-footer>
      <button type="button" class="btn text-white" (click)="overCurrentSplitConfirmation.accept()" style="width: 80px">OK</button>
      <button type="button" class="btn btn-cancel" (click)="overCurrentSplitConfirmation.reject()">Cancel</button>
    </p-footer>
  </p-confirmDialog>
  <p-confirmDialog header="WARNING!" #splitInvalidDelete key="splitInvalidDelete">
    <p-footer>
      <button type="button" class="btn text-white" (click)="splitInvalidDelete.accept()" style="width: 80px">OK</button>
    </p-footer>
  </p-confirmDialog>
</div>

<ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled">
  <div id="calanderDayParent{{ date.day }}{{ date.month }}{{ date.year }}" *ngIf="date.month === currentMonth" style="width:50px; margin-left:-10px">
    <div
      class="customCss"
      [class.hidden]="date.month !== currentMonth"
      id="calanderDayChild00{{ date.day }}{{ date.month }}{{ date.year }}"
      data-toggle="tooltip"
      data-placement="top"
      title=""
      placeholder="dd/mm/yyyy"
    >
      {{ date.day }}
    </div>
    <div id="calanderValue{{ date.day }}{{ date.month }}{{ date.year }}" style="justify-content: center; font-size: x-small"></div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <hr class="my-0" />
  <!-- <button class="btn btn-primary btn-sm m-2 float-end" (click)="setDate()">DONE</button> -->
</ng-template>
